<template>
  <div class="body-div">
    <div class="top-div">
      <div class="endpoint-calls">

      </div>
      <div
        class="overall-call-center"
        v-if="!Array.isArray(liveCallCenterStats)"
      >
        <span
          v-if="
            liveCallCenterStats['yesterday'].conversion >=
              liveCallCenterStats['30_days'].conversion
          "
        >
          To Managers:<br />
          Viki: Yesterday call center did
          {{ liveCallCenterStats["yesterday"].conversion }} CR -
          {{
            Math.abs(
              liveCallCenterStats["yesterday"].conversion -
                liveCallCenterStats["30_days"].conversion
            ).toFixed(2)
          }}<br />
          above the average - Great Job!
          <br />
        </span>
        <span v-else>
          To Managers:<br />
          Viki: Yesterday call center did
          {{ liveCallCenterStats["yesterday"].conversion }} CR -
          {{
            Math.abs(
              liveCallCenterStats["30_days"].conversion -
                liveCallCenterStats["yesterday"].conversion
            ).toFixed(2)
          }}
          below the average - push for more upgrade!<br />
        </span>
      </div>
      <div v-if="!Array.isArray(liveCallCenterStats)">Agent Information:</div>

      <div class="performance-tables">
        <table v-if="!Array.isArray(liveCallCenterStats)">
          <tr>
            <th>Agent name</th>
            <th>Yesterday CR</th>
            <th>30 days CR</th>
          </tr>
          <tr
            class="underperforming"
            v-for="agent in liveAgentsStats"
            v-bind:key="agent"
            v-if="
              agent['yesterday'].conversion > 0 &&
                agent['30_days'].conversion >= agent['yesterday'].conversion
            "
          >
            <td>
              {{ salesPersonList.find(item => item.id === agent.id).full_name }}
            </td>
            <td>{{ agent["yesterday"].conversion }}</td>
            <td>{{ agent["30_days"].conversion }}</td>
          </tr>
        </table>

        <table v-if="!Array.isArray(liveCallCenterStats)">
          <tr>
            <th>Agent name</th>
            <th>Yesterday CR</th>
            <th>30 days CR</th>
          </tr>
          <tr
            class="overperforming"
            v-for="agent in liveAgentsStats"
            v-bind:key="agent"
            v-if="
              agent['yesterday'].conversion > 0 &&
                agent['30_days'].conversion < agent['yesterday'].conversion
            "
          >
            <td>
              {{ salesPersonList.find(item => item.id === agent.id).full_name }}
            </td>
            <td>{{ agent["yesterday"].conversion }}</td>
            <td>{{ agent["30_days"].conversion }}</td>
          </tr>
        </table>
      </div>

      <!--      <table-->
      <!--        v-for="agent in liveAgentsStats"-->
      <!--        v-bind:key="agent"-->
      <!--        v-if="agent['yesterday'].conversion > 0"-->
      <!--      >-->
      <!--        <span class="agent-message">-->
      <!--          To Agent: <br />-->
      <!--          Viki: Yesterday you-->
      <!--          {{ salesPersonList.find(item => item.id === agent.id).full_name }}-->
      <!--          <span-->
      <!--            v-if="agent['30_days'].conversion >= agent['yesterday'].conversion"-->
      <!--          >-->
      <!--            fall down below this CR-->
      <!--            {{ agent["30_days"].conversion }}, and got only-->
      <!--            {{ agent["yesterday"].conversion }}-->
      <!--            => push for more upgrades-->
      <!--          </span>-->
      <!--          <span v-else>-->
      <!--            made above this CR-->
      <!--            {{ agent["30_days"].conversion }}, your CR was:-->
      <!--            {{ agent["yesterday"].conversion }}-->
      <!--            => Great Job! Continue this way-->
      <!--          </span>-->
      <!--        </span>-->
      <!--        <span class="agent-message">-->
      <!--          To Managers: <br />-->
      <!--          Viki: Yesterday-->
      <!--          {{ salesPersonList.find(item => item.id === agent.id).full_name }}-->
      <!--          <span-->
      <!--            v-if="agent['30_days'].conversion >= agent['yesterday'].conversion"-->
      <!--          >-->
      <!--            fall down below this CR-->
      <!--            {{ agent["30_days"].conversion }}, and got only-->
      <!--            {{ agent["yesterday"].conversion }}-->
      <!--            => work with him to enlarge his upgrades-->
      <!--          </span>-->
      <!--          <span v-else>-->
      <!--            made above this CR-->
      <!--            {{ agent["30_days"].conversion }}, his CR was:-->
      <!--            {{ agent["yesterday"].conversion }}-->
      <!--            => did a great job-->
      <!--          </span>-->
      <!--        </span>-->
      <!--        <br />-->
      <!--        <span class="call-center-agent">-->
      <!--          Viki: The Agent-->
      <!--          {{ salesPersonList.find(item => item.id === agent.id).full_name }}-->
      <!--          standings in regards to the entire call-center are: <br />Agent last-->
      <!--          30 days average: {{ agent["30_days"].conversion }}<br />-->
      <!--          Agent yesterday average: {{ agent["yesterday"].conversion }}<br />-->
      <!--          Call-Center last 30 days average:-->
      <!--          {{ liveCallCenterStats["30_days"].conversion }}<br />-->
      <!--          Call-Center yesterday average:-->
      <!--          {{ liveCallCenterStats["yesterday"].conversion }}-->
      <!--          <hr />-->
      <!--        </span>-->
      <!--      </table>-->

      <!--      <loader class="loader" :size="'8px'" v-if="liveStatsBusy"></loader>-->
      <div class="loader-div" v-if="liveStatsBusy">
        <!--        <loader :size="'8px'"></loader>-->
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "LiveVikiCR.container",
  // components: { Loader },
  data() {
    return {
      liveStatsBusy: false,
      liveAgentsStats: [],
      liveCallCenterStats: []
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  mounted() {
    this.getLiveCRStats();
  },
  created() {},
  methods: {
    async getLiveCRStats() {
      this.liveAgentsStats = [];
      this.liveCallCenterStats = [];
      if (
        !this.liveStatsBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.liveStatsBusy = true;
          const res = await apiClientCreator(
            `live_stats/conversion_live_stats/true`
          ).get("");
          this.liveAgentsStats = res.data["users"];
          this.liveCallCenterStats = res.data["call_center"];
          this.liveStatsBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0 1.5em;
}
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.loader {
  left: 0;
  right: 0;
}

.endpoint-calls {
  display: flex;
  justify-content: center;
  padding: 2em 0;
}
.overall-call-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.performance-tables {
  display: flex;
  justify-content: space-around;
  padding: 2em 0;
}
.underperforming {
  color: red;
}
.overperforming {
  color: green;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 45%;
  top: 80px;
}
</style>
